import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-ink text-parchment mt-32" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="overline !text-brass">Established Trust</div>
          <h3 className="h-serif text-3xl mt-3 max-w-sm">
            Discreet brokerage for institutional procurement teams.
          </h3>
          <p className="text-sub mt-5 text-sm leading-relaxed max-w-md">
            Campbell&apos;s Commodities Brokerage LLC operates as a private intermediary
            for verified corporate buyers across energy and soft commodity markets.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="overline !text-brass">Navigate</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/" className="hover:text-brass">Home</Link></li>
            <li><Link to="/process" className="hover:text-brass">How It Works</Link></li>
            <li><Link to="/commodities" className="hover:text-brass">Commodities &amp; Sectors</Link></li>
            <li><Link to="/suppliers" className="hover:text-brass">Suppliers</Link></li>
            <li><Link to="/about" className="hover:text-brass">About</Link></li>
            <li><Link to="/trust" className="hover:text-brass" data-testid="footer-trust-link">Trust &amp; Compliance</Link></li>
            <li><Link to="/login" className="hover:text-brass">Request Access</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="overline !text-brass">Confidential Intake</div>
          <p className="mt-4 text-sm text-sub">
            Supplier rosters, pricing tiers, and shipment lanes are disclosed only
            inside the vetted platform. Public correspondence is intentionally limited.
          </p>
          <p className="mt-4 text-sm text-parchment font-mono">
            intake@campbellscommoditiesbrokeragellc.com
          </p>
        </div>
      </div>
      <div className="border-t border-ink2">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex items-center justify-between text-xs text-sub">
          <div>© {new Date().getFullYear()} Campbell&apos;s Commodities Brokerage LLC. All rights reserved.</div>
          <div className="font-mono">Delaware · United States</div>
        </div>
      </div>
    </footer>
  );
}
